module.exports = __webpack_public_path__ + "img/isl.2ce20c50.svg";